import axios from '@/api/config';

const signInLog = {
    getNoSignInClassInfoStudentList(data) {
        return axios.get(`${process.env.BASE_URL}/classInfoStudent/getNoSignInClassInfoStudentList`, { params: data });
    },
    getClassInfoList(data) {
        return axios.get(`${process.env.BASE_URL}/classInfo/getClassInfoList`, { params: data });
    },
    getPlanListByClassInfoIdt(data) {
        return axios.get(`${process.env.BASE_URL}/signInLog/getPlanListByClassInfoId`, { params: data });
    },
    getAttachmentList(data) {
        return axios.get(`${process.env.BASE_URL}/attachment/getAttachmentList`, { params: data });
    },
    batchAddChapterMaterialsForPlan(data) {
        return axios.post(`${process.env.BASE_URL}/chapterMaterials/batchAddChapterMaterialsForPlan`, data);
    },
    batchUpdateChapterMaterialsForPlan(data) {
        return axios.post(`${process.env.BASE_URL}/chapterMaterials/batchUpdateChapterMaterialsForPlan`, data);
    },
    chapterMaterialsAactive(data) {
        return axios.post(`${process.env.BASE_URL}/chapterMaterials/active`, data);
    },
    chapterMaterialsList(data) {
        return axios.get(`${process.env.BASE_URL}/classCourseDetail/chapterMaterialsList`, { params: data });
    },
    // 之前的获取 签到列表接口
    pageList(data) {
        return axios.post(`${process.env.BASE_URL}/classInfoStudent/pageList`, data);
    },
    // 签到列表接口
    signList(data) {
        return axios.post(`${process.env.BASE_URL}/classInfoStudent/signList`, data);
    },
    // chapterMaterialsDetailByQuestionId(data) {
    //     return axios.get(`${process.env.BASE_URL}/chapterMaterials/chapterMaterialsDetailByQuestionId`, { params: data });
    // },
    chapterMaterialsDetailByQuestionId(data) {
        return axios.get(`${process.env.BASE_URL}/practice/practiceDetailByQuestionId`, { params: data });
    },
    copyDefaultChapterMaterials(data) {
        return axios.get(`${process.env.BASE_URL}/classCourseDetail/copyDefaultChapterMaterials`, { params: data });
    },
    // deleteClassCourseDetail(data) {
    //     return axios.get(`${process.env.BASE_URL}/chapterMaterials/deleteClassCourseDetail`, { params: data });
    // },
    deleteClassCourseDetail(data) {
        return axios.delete(`${process.env.BASE_URL}/practice/deletePracticeById`, { data: { id: data.id } });
    },
    getScheduleInfoListByClassInfoId(data) {
        return axios.get(`${process.env.BASE_URL}/signInLog/getScheduleInfoListByClassInfoId`, { params: data });
    },
    // 获取考试期数
    getSequenceListBySubjectId(data) {
        return axios.get(`${process.env.BASE_URL}/examinationSetting/getSequenceListBySubjectId`, { params: data });
    },
    // 清除缓存
    cleanExaminationExamQuestionCache() {
        return axios.get(`${process.env.BASE_URL}/examinationSetting/cleanExaminationExamQuestionCache`);
    },
    // 获取抓拍数据
    getExaminationPhotoSetting() {
        return axios.get(`${process.env.BASE_URL}/examinationPhotoSetting/getExaminationPhotoSetting`);
    },
    // 获取添加试卷期数
    getSequence(data) {
        return axios.get(`${process.env.BASE_URL}/examinationSetting/getSequence`, { params: data });
    },
    // 获取试卷设置信息
    getExaminationSettingDetail(data) {
        return axios.get(`${process.env.BASE_URL}/examinationSetting/getExaminationSettingDetail`, { params: data });
    },
    // 获取考试试卷
    getExamList(data) {
        return axios.get(`${process.env.BASE_URL}/exam/getExamList`, { params: data });
    },
    // 获取报名信息设置信息
    getFieldList(data) {
        return axios.get(`${process.env.BASE_URL}/field/getFieldList`, { params: data });
    },
    // 获取审批人
    getAgentTeacherList() {
        return axios.get(`${process.env.BASE_URL}/agentUserInfo/getAgentTeacherList`);
    },
    // 判断是否需要审批人
    validExaminationTeacherByExamId(data) {
        return axios.get(`${process.env.BASE_URL}/examinationTeacherRelation/validExaminationTeacherByExamId`, { params: data });
    },
    // 获取试卷列表
    getExamPageList(data) {
        return axios.post(`${process.env.BASE_URL}/examinationSetting/pageList`, data);
    },
    // 添加试卷
    addExaminationSetting(data) {
        return axios.post(`${process.env.BASE_URL}/examinationSetting/addExaminationSetting`, data);
    },
    // 抓拍设置
    addExaminationPhotoSetting(data) {
        return axios.post(`${process.env.BASE_URL}/examinationPhotoSetting/addExaminationPhotoSetting`, data);
    },
    // 试卷设置提交
    updateExaminationSetting(data) {
        return axios.post(`${process.env.BASE_URL}/examinationSetting/updateExaminationSetting`, data);
    },
    // 删除考试
    deleteExaminationSetting(data) {
        return axios.delete(`${process.env.BASE_URL}/examinationSetting/deleteExaminationSetting`, { data: data });
    },
    exportSignInLog(data) {
      return axios.post(`${process.env.BASE_URL}/signInLog/exportExcel`, data);
    },
}
export default signInLog;



// WEBPACK FOOTER //
// ./src/api/signInLog.js